<template>
  <HTextfield
    v-model:value="name"
    label="Nome do Canal"
    placeholder="Ex: Dor de Barriga"
    :max-length="35"
    name="channel-rename"
    :disabled="disableRename"
    @blur="renameChannel"
    @keydown.enter="renameChannel"
  />
</template>

<script>
import { HTextfield } from '@/components/shared/atoms'

export default {
  components: { HTextfield },
  props: {
    channelName: { type: String, default: undefined },
    classifier: { type: String, default: undefined }
  },
  emits: ['changeName'],
  data() {
    return {
      name: ''
    }
  },
  computed: {
    disableRename() {
      return !!this.classifier
    }
  },
  watch: {
    channelName: {
      immediate: true,
      handler() {
        this.name = this.channelName || ''
      }
    }
  },
  methods: {
    renameChannel() {
      if (!this.name || this.channelName === this.name) {
        this.name = this.channelName
        return
      }
      this.$emit('changeName', this.name)
    }
  }
}
</script>
